module.exports = __webpack_public_path__ + "static/media/totalRequestIcon.c581fbbe.svg";